<template>
  <div v-if="dataNotNull" key="1" class="equipmentDiv" style="width: 100%; height: 100%">
    <div class="container1" style="margin:15px 0 0 25px;height: 100%;"></div>
  </div>
  <div v-else key="2" style="width: 100%; height: 100%;">
    <div class="title_equipment">Total Major Equipment Registered <br/>(By Project)
    </div>
    <div class="zero_equipment">No Data !</div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  name: "equipment",
  data() {
    return {
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "equipment",
      dataNotNull: true
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
  },
  mounted() {
    var that = this
    this.myChart = echarts.init(document.querySelector('.equipmentDiv .container1'))
    this.myChart.setOption({
      title: {
        text: "Total Major Equipment Registered \n" + "(By Project)",
        textStyle: {
          color: '#FFF',
          fontSize: 16
        }
      },
      tooltip: {
        show: true,
        trigger: 'axis'
      },
      dataZoom: [
        {
          show: true,
          realtime: true,
          xAxisIndex: [0],
          left: '95%',
          startValue: 0, // 从头开始。
          endValue: 1,  // 一次性展示5个。
          showDetail: false,
          zoomLock: true,
          width: '3%',
          orient: "vertical"
        }
      ],
      xAxis: {
        type: "category",
        data: [],
        axisLine: {
          lineStyle: {
            color: '#FFF',
            fontSize: 13
          }
        }
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
        axisLine: {
          lineStyle: {
            color: '#6CF'
          }
        }
      },
      series: [{
        data: [],
        barWidth: '25%',
        type: 'bar',
        itemStyle: {
          normal: {
            color: function (params) {
              // var colorList = ['#B077F3', '#81EEFE', '#FD935C', '#F2E36B']
              var colorList = that.$store.state.color.chart_color
              return colorList[params.dataIndex]
            }
          },
          //鼠标悬停时：
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }],
    })

    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });

    let postData = {
      cms_conid: window.localStorage.getItem('cons_id'),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getCmsServer + "DBConEquip", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var legends = []
        var safeties = []
        var result = resp.data.result;
        for (var i in result) {
          legends.push(result[i].program_name.slice(0, 12) + '\n' + result[i].program_name.slice(12))
          // legends = ['LTA\nT311','TheLan\nd mark','Norman\nton Park','Tagore\nESS']
          safeties.push(result[i].count)
        }
        this.myChart.setOption({
          xAxis: {
            data: legends,
          },
          series: [{
            data: safeties
          }]
        })
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert("DBConEquip.error:" + error)
      this.dataNotNull = false
      this.myChart.hideLoading()
    })
  }
}
</script>

<style lang="stylus" scoped>
.title_equipment
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 30px

.zero_equipment
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>



// WEBPACK FOOTER //
// src/components/constractor/equipment.vue